import styled from '@emotion/styled'

// Экран успеха живёт в том же (широком) белом блоке, что и форма. Центрируем
// контент, чтобы медведь с текстом не были прижаты влево с пустым полем до крестика.
export const SuccessWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const ButtonsWrapper = styled.div`
  margin-top: ${({ theme }) => theme.sizes.twoBase};
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
`
